import axios from '../../axios';

//加载头文件
//import * as StkInProductApi from './moudules/stk/StkInProductApi'; //产成品入库单
//  StkInProductApi,//产成品入库单

// 产成品入库单列表
export const getStkInProductPage = data => {
  return axios({
    url: '/api/sys/stk/getStkInProductPage',
    method: 'post',
    data
  })
};
// 产成品入库总合计
export const getStkInProductSum = data => {
  return axios({
    url: '/api/sys/stk/getStkInProductSum',
    method: 'post',
    data
  })
};
// 产成品入库单保存
export const saveStkInProduct = data => {
  return axios({
    url: '/api/sys/stk/saveStkInProduct',
    method: 'post',
    data
  })
};

// 产成品入库单修改
export const updateStkInProduct = data => {
  return axios({
    url: '/api/sys/stk/updateStkInProduct',
    method: 'post',
    data
  })
};

// 产成品入库单删除
export const deleteStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/deleteStkInProducts',
    method: 'post',
    data
  })
};

// 产成品入库单查单条
export const getStkInProduct = data => {
  return axios({
    url: '/api/sys/stk/getStkInProduct',
    method: 'post',
    data
  })
};

// 产成品入库单审核
export const auditStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/auditStkInProducts',
    method: 'post',
    data
  })
};
// 产成品入库单反审核
export const unauditStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/unauditStkInProducts',
    method: 'post',
    data
  })
};

// 产成品入库单作废
export const cancelStkInProducts = data => {
  return axios({
    url: '/api/sys/stk/cancelStkInProducts',
    method: 'post',
    data
  })
};


// WEBPACK FOOTER //
// ./src/api/moudules/stk/StkInProductApi.js